import {
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { Link } from "react-router-dom";

import { Button, Typography } from "~/common/components";
import BackArrow from "~/common/components/icons/BackArrow";
import { useConfirmStripePayment } from "~/patients/hooks/queries/payments/useCreatePayment";
import { ROUTES } from "~/patients/router";

export const CheckoutForm = ({ amount }: { amount?: number }) => {
  const stripe = useStripe();
  const elements = useElements();
  const { createPaymentMutation, isPending } = useConfirmStripePayment();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    createPaymentMutation();
  };

  return (
    <form
      className="flex h-screen-calculated flex-col justify-between bg-primary-50 p-8 md:px-64"
      id="payment-form"
      onSubmit={handleSubmit}
    >
      <div className="flex flex-col gap-6">
        <Link
          to={ROUTES.leadPatientHome}
          className="flex flex-row items-center gap-1"
        >
          <BackArrow className="size-5" />
          Home
        </Link>
        <Typography className="font-outfit text-3xl font-semibold">
          Payment
        </Typography>
        <Typography className="text-lg text-primary">
          Amount due <br /> <span className="font-medium">${amount}</span>
        </Typography>
        <PaymentElement id="payment-element" />
      </div>
      <Button
        isLoading={isPending}
        disabled={!stripe || !elements}
        type="submit"
      >
        Pay and continue
      </Button>
    </form>
  );
};
